var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserProfileIconN(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9996 18L16.9999 15.0003C17 13.3433 15.6568 12 13.9999 12H6.00046C4.34374 12 3.00065 13.3429 3.00046 14.9997L3.00012 18M13.0001 5C13.0001 6.65685 11.657 8 10.0001 8C8.34327 8 7.00012 6.65685 7.00012 5C7.00012 3.34315 8.34327 2 10.0001 2C11.657 2 13.0001 3.34315 13.0001 5Z",
    stroke: "#FAFAFA",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserProfileIconN);
export default __webpack_public_path__ + "static/media/UserProfileIconN.fd0fb00c67ba131ea60301877b69f6ad.svg";
export { ForwardRef as ReactComponent };